import { createApi } from '@core/fetch'

export default {
  contactList: createApi('/p/wedding/index.php/Admin/APIMerchant/connectUs'),
  leaveMsg: createApi.post('/p/wedding/index.php/Admin/APIMerchant/merMessage')
}
